import {useEffect} from 'react'
import {QueryHookOptions, useQuery as useQueryOrigin} from '@apollo/client'
import {QueryResult, OperationVariables} from '@apollo/client'
import {useDispatch} from 'react-redux'
import {handleQueryError} from 'libs/graphql'

// oxlint-disable-next-line typescript/no-explicit-any
export const useQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>(
  // oxlint-disable-next-line typescript/no-explicit-any
  query: any,
  options?: QueryHookOptions<TData, TVariables>
): QueryResult<TData, TVariables> => {
  const dispatch = useDispatch()
  const queryResult = useQueryOrigin<TData, TVariables>(query, options)

  useEffect(() => {
    if (queryResult.error) {
      handleQueryError(queryResult.error, dispatch)
    }
  }, [dispatch, queryResult.error])

  return queryResult
}
